import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Grid,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  IconButton,
  Typography,
} from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import TopButton from "../../Components/UI/TopButtons";
import Placeholder from "../../Components/UI/Placeholder";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import Slide from "@mui/material/Slide";

import { commonSliceActions } from "../../Store/Slices/CommonSlice";
import { getEvaluateAssignmentData } from "./Services";

const AssessAssignmentList = (props) => {
  //Hooks
  const styles = useStyles();
  const navigation = useNavigate();
  const dispatch = useDispatch();

  // Redux state
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);

  // State
  const [assignments, setAssignments] = useState([]);

  useEffect(() => {
    fetchAssignments();
  }, []);

  // Route redirect function
  const goTo = (assignmentId, name) => {
    // console.log(assignmentId, "=====",name);
    dispatch(
      commonSliceActions.setParamsData({
        assignmentId: assignmentId,
        assignmentName: name,
      })
    );
    navigation(`/Assess/AssetsList`);
  };

  // Fetch Assignment Data
  const fetchAssignments = async () => {
    let assignmentData = await getEvaluateAssignmentData(
      userInfo.uid,
      userInfo.site_uuid
    );
    console.log("assignmentData.data", assignmentData.data);
    setAssignments(assignmentData.data);
  };

  return (
    <>
      <TopButton
        title={"Evaluate Assignments"}
        secondaryText={"Assignments List"}
        // isReportFilter={true}
        // handleFilter={handleFilterData}
      />

      <Grid
        container
        spacing={2}
        className={styles.scrollBar}
        sx={{
          px: 5,
          height: "75vh",
          overflow: "auto",
          justifyContent: "flex-start",
          alignContent: "flex-start",
        }}
      >
        {assignments &&
          assignments.length > 0 &&
          assignments.map((assignmentData, index) => {
            return (
              <Slide
                direction="up"
                timeout={500}
                in={true}
                mountOnEnter
                unmountOnExit
              >
                <Grid
                  item
                  xs={6}
                  sx={{ padding: "0px", mt: 2 }}
                  key={`${"eval_" + index}`}
                >
                  <List sx={{ padding: "0px", margin: "0px !important" }}>
                    <ListItem
                      disablePadding
                      sx={{
                        borderRadius: 2,
                        padding: 0,
                        backgroundColor: "#F5F7FF",
                      }}
                      onClick={() => {
                        goTo(assignmentData.uid, assignmentData.title);
                      }}
                      secondaryAction={
                        <>
                          {assignmentData.assetType == "BOOK" && (
                            <IconButton
                              edge="end"
                              au6ria-label="comments"
                              sx={{ backgroundColor: "#FFFFFF", mx: 1 }}
                            >
                              <MenuBookIcon
                                sx={{
                                  color: "#DB8829",
                                  fontSize: "1.2rem",
                                  "@media (min-width: 1636px)": {
                                    fontSize: "2rem",
                                  },
                                }}
                              />
                            </IconButton>
                          )}
                          <IconButton
                            edge="end"
                            au6ria-label="comments"
                            sx={{
                              color: "primary.main",
                              backgroundColor: "#FFFFFF",
                            }}
                          >
                            <NavigateNextIcon
                              sx={{
                                fontSize: "1.2rem",
                                "@media (min-width: 1636px)": {
                                  fontSize: "2rem",
                                },
                              }}
                            />
                          </IconButton>
                        </>
                      }
                      // className={`${(selectedQType == assignmentData.uid) ? styles.activeText : ""}`}
                    >
                      <ListItemButton sx={{ borderRadius: 5 }} dense>
                        <ListItemText>
                          <Typography
                            sx={{
                              color: "primary.main",
                              fontSize: "1rem",
                              fontWeight: "600",
                              "@media (min-width: 1636px)": {
                                fontSize: "1.4rem",
                              },
                            }}
                          >
                            {assignmentData.title}
                          </Typography>
                          <Typography
                            sx={{
                              color: "#A9A9A9",
                              fontSize: "0.75rem",
                              fontWeight: "600",
                              "@media (min-width: 1636px)": {
                                fontSize: "1.2rem",
                              },
                            }}
                          >
                            {assignmentData.assetType == "BOOK" ? (
                              <>{"Library"}</>
                            ) : (
                              <>&nbsp;</>
                            )}
                          </Typography>
                        </ListItemText>
                      </ListItemButton>
                    </ListItem>
                  </List>
                </Grid>
              </Slide>
            );
          })}

        {!assignments ||
          (assignments.length == 0 && (
            <Placeholder
              primaryText="No assignment found"
              secondaryText="No assignment available for evaluation"
              image="assign"
            ></Placeholder>
          ))}
      </Grid>
    </>
  );
};
const useStyles = makeStyles({
  activeText: {
    backgroundColor: "#d7e2f2",
  },
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});

export default AssessAssignmentList;
